<template>
  <div id="users" class="users" v-bind:key="componentKey">
    <!-- v-bind:key="componentKey" -->
    <div
      :id="'users_' + type"
      style="overflow-y: auto;"
      v-resize="onResizeUserList"
      :style="{ height: userListHeight + 'px' }"
      @scroll="onUserScroll"
      class="custom-scroll"
    >
      <div :id="'users_' + type + '_container'">
        <v-layout justify-center column fill-height v-if="userloading || usersearching">
          <div class="text-xs-center mt-4 mb-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>
        </v-layout>
        <template v-else-if="livechatUsers(type) && livechatUsers(type).length > 0">
          <div
            v-for="(user, index) in sortedUsers"
            :key="'user-' + index + '-' + user.userid"
            @click="selectUser(user)"
            class="user"
          >
            <!-- v-if="logReadOrUnread(type, index)" -->
            <user-item
              v-if="logReadOrUnread(type, index)"
              v-model="livechatUsers(type)[index]"
              :livechatUsersData="livechatUsers(type)[index]"
              :selected="selectedUser != null && user.userid == selectedUser.userid"
              :key="livechatUsers(type)[index].userid"
            ></user-item>
            <!-- <v-divider></v-divider> -->
          </div>
          <!-- <div
            v-if="loadmore"
            class="text-xs-center"
            style="background:#eee;padding-top:10px;padding-bottom:10px"
          >
            <v-progress-circular indeterminate color="grey" small class="mr-2" :width="2"></v-progress-circular>Loading
          </div>-->
          <!-- <template v-if="isMobile">
            <div
              class="text-xs-center"
              style="background: #eee; padding-top: 10px; padding-bottom: 10px"
              @click="onLoadmore"
            >
              <template v-if="loadmore">
                <v-progress-circular
                  indeterminate
                  color="grey"
                  small
                  class="mr-2"
                  :width="2"
                ></v-progress-circular
                >Loading
              </template>
              <template v-else @click="onLoadmore"
                >Click to load more conversation</template
              >
            </div>
          </template>
          <template v-else> -->
          <template>
            <div
              v-if="loadmore"
              class="text-xs-center"
              style="background: #eee; padding-top: 10px; padding-bottom: 10px"
            >
              <v-progress-circular
                indeterminate
                color="grey"
                small
                class="mr-2"
                :width="2"
              ></v-progress-circular
              >Loading
            </div>
          </template>
        </template>
        <v-layout justify-center column fill-height v-else>
          <div class="text-xs-center mt-4 mb-4">
            <img src="/static/img/assets/livechat/no_user.png" alt />
            <div>No users</div>
          </div>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import userItem from './livechat-user-item'
import api from '@/api'
import { eventBus } from './event-bus.js'

export default {
  props: ['value', 'type', 'app', 'filter', 'isMobile', 'usersearching'],
  data: function() {
    return {
      componentKey: 0,
      view_ticket: '',
      loading: true,
      userloading: true,
      maxTime: 15000,
      timer: '',
      windowHeight: 0,
      userListHeight: 0,
      limit: 20,
      offset: 0,
      users: [],
      isAutoRefresh: true,
      loadmore: false
      // filter: {},
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      livechatUsers: 'getLivechatUsers',
      selectedUser: 'getCurrentUser',
      searchlist: 'getLivechatSearching',
      agentGroup: 'getAgentGroup',
      agentSubGroup: 'getAgentSubgroup'
    }),
    currentTheme() {
      return this.$store.state.livechat.theme
        ? this.$store.state.livechat.theme
        : this.selectedBot.theme
    },
    sortedUsers: function() {
      var vm = this
      // console.log(vm.livechatUsers(vm.type))
      var users = vm.livechatUsers(vm.type)
      // users = vm.livechatUsers(vm.type).sort(function(a, b) {
      //   return new Date(b.lastreply_time) - new Date(a.lastreply_time)
      // })
      return users
    }
  },
  components: {
    'user-item': userItem
  },
  created: function() {
    eventBus.$on('ReadFilterOrUnread-event', this.handleCustomEvent)
    let vm = this.filters

    vm.timer = setInterval(() => {
      vm.$store.dispatch('loadLatestUsers', {
        type: vm.type
      })
    }, vm.$store.state.livechat.maxFatchUserTime)
  },
  mounted: async function() {
    // console.log(this.$store.state.livechat)

    let vm = this
    vm.userloading = true
    if (vm.selectedBot.theme == 'ticket') {
      await vm.initTicket()
      vm.initFilter()
    }
    try {
      vm.$set(vm.$store.state.livechat, 'app', vm.app)
      await vm.$store.dispatch('loadLatestUsers', {
        type: vm.type
      })
      vm.userloading = false
      vm.onResizeUserList()
    } catch (error) {
      // console.log("loadLatestUsers err", error)
      vm.userloading = false
      vm.$swal.fire({
        title: 'Load failed',
        // title: error,
        type: 'error',
        confirmButtonText: vm.$t('Confirm')
      })
    } finally {
      vm.userloading = false
    }
  },
  methods: {
    handleCustomEvent() {
      // การดำเนินการที่ต้องการเมื่อรับ Event
      // console.log("user event")
      // this.$forceUpdate()
      this.componentKey += 1
    },
    logReadOrUnread(type, index) {
      return (
        (localStorage.getItem('ReadFilter') == 'true' &&
          this.livechatUsers(type)[index].unread_count == 0) ||
        (localStorage.getItem('UnReadFilter') == 'true' &&
          this.livechatUsers(type)[index].unread_count != 0) ||
        (localStorage.getItem('ReadFilter') == 'false' &&
          localStorage.getItem('UnReadFilter') == 'false')
      )

      // return true
    },
    initTicket() {
      return new Promise(async resolve => {
        await this.$store.dispatch('loadAgents')
        await this.$store.dispatch('loadAgentGroups')
        await this.$store.dispatch('loadAgentSubGroups')
        resolve()
      })
    },
    onUserScroll: async function() {
      var vm = this
      if (vm.isMobile) {
        return false
      }
      let messages = $('#users_' + vm.type)
      let scrollPosition = messages.scrollTop()
      let chatboxHeight = messages.outerHeight(true)
      let totalHeight = messages.prop('scrollHeight')

      if (scrollPosition <= chatboxHeight) {
        vm.enableAutoUpdate(true)
      }
      if (Math.abs(Math.round(scrollPosition + chatboxHeight) - totalHeight) < 3) {
        vm.enableAutoUpdate(false)
        await vm.onLoadmore()
      }
    },
    enableAutoUpdate: function(enable) {
      this.$set(this.$store.state.livechat.userlist[this.type], 'isAutoRefresh', enable)
    },
    onResizeUserList: function() {
      var vm = this
      vm.$nextTick(function() {
        if (document.getElementById('chattype')) {
          vm.userListHeight =
            window.innerHeight -
            document.getElementById('main_toolbar').clientHeight -
            document.getElementById('chattype').clientHeight -
            40
        }
      })
    },
    selectUser: async function(user) {
      user.type = this.type
      this.$store.commit('SET_LIVECHAT_USER', user)

      this.$emit('onClickUser')
      var vm = this
      api.adminreadchat(
        {
          adminid: this.$store.state.userid,
          userid: user.userid
        },
        () => {
          vm.$nextTick(() => {
            user.adminread = true
            vm.$store.commit('SET_LIVECHAT_USER', user)
            vm.$forceUpdate()
          })
        }
      )
    },
    getLatestChatUsers: function() {
      var vm = this
      if (vm.loading) {
        return false
      }
      let limit = 20
      if (vm.livechatUsers(vm.type).length == 0) {
        limit = 20
      }

      vm.getLiveChatUsers(0, limit, true).then(
        function(users) {
          vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: users })
        },
        function(error) {
          // console.log(error)
        }
      )
    },
    initFilter() {
      var admingroupid = this.$store.state.admingroupid
      var adminsubgroupid = this.$store.state.adminsubgroupid
      var filter = {}
      var group = {}
      var subgroup = {}

      this.agentGroup.map(el => {
        group[el.id] = el
      })
      this.agentSubGroup.map(el => {
        subgroup[el.id] = el
      })

      // var group = this.agentGroup
      this.view_ticket = this.$store.state.privilege.view_ticket
      if (this.view_ticket == 'all') {
        // dont do shit
      } else if (this.view_ticket == 'only_me') {
        this.filter.assignadminid = this.$store.state.userid
        Object.assign(filter, {
          assignadminid: this.$store.state.userid
        })
        if (admingroupid || admingroupid === 0) {
          this.filter.assigngroupid = group[admingroupid].id
        }
        if (adminsubgroupid || adminsubgroupid === 0) {
          this.filter.assignsubgroupid = subgroup[adminsubgroupid].id
        }
        if (this.agents) {
          this.filter.admin = this.agents.find(el => el.adminid == this.$store.state.userid)
        }
      } else if (this.view_ticket == 'only_group') {
        Object.assign(filter, {
          assigngroupid: admingroupid
        })

        if (admingroupid || admingroupid === 0) {
          this.filter.assigngroupid = group[admingroupid].id
        }
      } else if (this.view_ticket == 'only_subgroup') {
        Object.assign(filter, {
          assignsubgroupid: adminsubgroupid
        })
        if (admingroupid || admingroupid === 0) {
          this.filter.assigngroupid = group[admingroupid].id
        }
        if (adminsubgroupid || adminsubgroupid === 0) {
          this.filter.assignsubgroupid = subgroup[adminsubgroupid].id
        }
      }
    },
    getLiveChatUsers: function(offset, limit, latest) {
      let vm = this
      return new Promise((resolve, reject) => {
        vm.loading = true
        let data = {
          pageid: vm.$store.state.livechat.pageid,
          offset: offset,
          limit: limit,
          inbox: vm.type,
          app: vm.app,
          ...vm.filter
        }
        api.getLiveChatUsers(data, function(error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            vm.loading = false
            resolve(response.data)
          } else {
            resolve([])
          }
        })
      })
    },
    matchChatboxHeight: function() {
      let vm = this
      let totalHeight = vm.windowHeight
      let headerHeight = $('header').outerHeight(true)
      let typeHeight = $('#chattype').outerHeight(true)
      totalHeight = totalHeight - headerHeight - typeHeight
      $('.users').height(totalHeight)
    },
    onLoadmore: async function() {
      var vm = this
      if (vm.loadmore || !vm.$store.state.livechat.userlist[vm.type].hasMore) {
        return false
      }
      vm.loadmore = true

      vm.$set(
        vm.$store.state.livechat.userlist[vm.type],
        'limit',
        vm.$store.state.livechat.userlist[vm.type].limit + vm.$store.state.livechat.limitFatchUser
      )

      try {
        await vm.$store.dispatch('loadLivechatUsers', {
          type: vm.type
        })
        vm.loadmore = false
      } catch (error) {
      } finally {
        vm.loadmore = false
      }
    }
  },
  watch: {
    searchlist(newVal, oldVal) {
      if (newVal != oldVal) {
        this.onResizeUserList()
      }
    },
    // type: async function(newVal, oldVal) {
    //   let vm = this
    //   if (newVal != oldVal) {
    //     vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
    //     vm.userloading = true
    //     try {
    //       await vm.$store.dispatch('loadLivechatUsers', {
    //         type: vm.type
    //       })
    //       vm.userloading = false
    //     } catch (error) {
    //     } finally {
    //       vm.userloading = false
    //     }
    //   }
    // },
    app: async function(newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$set(vm.$store.state.livechat, 'app', newVal)
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type
          })
          vm.userloading = false
        } catch (error) {
          // console.log("app1 err", error)
        } finally {
          vm.userloading = false
          // console.log("app2 err", error)
        }
      }
    },
    selectedBot: async function(newVal, oldVal) {
      let vm = this
      if (newVal != oldVal) {
        vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
        vm.userloading = true
        try {
          await vm.$store.dispatch('loadLivechatUsers', {
            type: vm.type
          })
          vm.userloading = false
        } catch (error) {
        } finally {
          vm.userloading = false
        }
      }
    }
    // filter: {
    //   handler: async function(newVal, oldVal) {
    //     let vm = this
    //     if (newVal != oldVal) {
    //       // vm.$store.dispatch('updateLivechatUsers', { type: vm.type, users: [] })
    //       // vm.userloading = true
    //       // try {
    //       //   await vm.$store.dispatch('loadLivechatUsers', {
    //       //     type: vm.type
    //       //   })
    //       //   vm.userloading = false
    //       // } catch (error) {}
    //       vm.onResizeUserList()
    //     }
    //   },
    //   deep: true
    // },
  },
  beforeDestroy: function() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss" scoped>
.user {
  cursor: pointer;
  &:hover {
    background: #eee;
  }

  &:active {
    background: rgb(245, 244, 244);
  }
}

.custom-scroll::-webkit-scrollbar {
  width: 7px;
  height: 7px;
}

.custom-scroll::-webkit-scrollbar-track {
  background-color: #ffffff;
}

.custom-scroll::-webkit-scrollbar-thumb {
  background-color: #0c2f53;
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-users.vue